/**
 * Button Component
 * Reusable button with multiple variants and sizes
 */

import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  block = false,
  disabled = false,
  type = 'button',
  onClick,
  className = '',
  ...props
}) => {
  const baseClass = 'rf-btn';
  const variantClass = `rf-btn-${variant}`;
  const sizeClass = size !== 'md' ? `rf-btn-${size}` : '';
  const blockClass = block ? 'rf-btn-block' : '';

  const classes = [baseClass, variantClass, sizeClass, blockClass, className]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
